<template>
    <div class="internal-nav-box">
        <div v-if="isLogged" class="internal-nav-account">
            <div class="icon">
                <img/>
            </div>
            {{getEmail}}
        </div>
        <div class="av-logo">
            <a href="/"><span>AV</span>CHECK</a>
        </div>
        <div v-if="isLogged" class="internal-nav-buttons">
            <div v-if="isOnScan" class="main-btn">
                <a href="profile">Profile</a>
            </div>
            <div v-else class="main-btn">
                <a href="scan">Scan</a>
            </div>
            <div class="main-btn red">
                <a @click="logout">Logout</a>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'InternalNav',
        computed: {
            isLogged() {
                return this.$store.getters.isLoggedIn
            },
            isOnScan() {
                return this.$store.getters.isOnScan
            },
            getEmail() {
                return this.$store.getters.getUserEmail
            }

        },
        methods: {
            logout() {
                this.$store.commit('changeId', null)
                this.$store.commit('changeEmail', null)
                this.$router.push('/')
            }
        },
    }
</script>
